/* eslint-disable */

// This file was automatically generated by @icp-sdk/bindgen@0.4.1.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { ActorMethod } from '@icp-sdk/core/agent';
import type { Principal } from '@icp-sdk/core/principal';
import { IDL } from '@icp-sdk/core/candid';

export interface Asset { 'address' : string, 'standard' : string }
export interface Block { 'id' : bigint, 'block' : Value }
export interface GraphEdge {
  'to' : Principal,
  'from' : Principal,
  'transfers' : bigint,
  'last_block' : bigint,
  'first_block' : bigint,
  'amount' : bigint,
  'last_at' : [] | [bigint],
  'first_at' : [] | [bigint],
}
export interface GraphPage {
  'status' : { 'refreshing' : null } |
    { 'building' : null } |
    { 'error' : string } |
    { 'ready' : null },
  'snapshot' : [] | [GraphSnapshot],
  'next_refresh_at' : bigint,
  'mode' : Mode,
  'max_edges' : bigint,
  'error' : [] | [string],
  'target' : bigint,
  'max_infrastructure_edges' : bigint,
  'max_holders' : bigint,
  'ledger' : [] | [Principal],
  'market' : Principal,
  'max_tracked_edges' : bigint,
  'max_peer_edges' : bigint,
  'indexed' : bigint,
  'refresh_interval_seconds' : bigint,
}
export interface GraphSnapshot {
  'omitted_edges' : bigint,
  'updated_at' : bigint,
  'infrastructure_edges' : bigint,
  'transfers' : bigint,
  'edges' : Array<GraphEdge>,
  'omitted_infrastructure_transfers' : bigint,
  'omitted_transfers' : bigint,
  'holder_count' : bigint,
  'version' : bigint,
  'holder_edges' : bigint,
  'supply' : bigint,
  'holders' : Array<Holder>,
  'capped' : boolean,
  'omitted_peer_transfers' : bigint,
  'peer_edges' : bigint,
  'indexed' : bigint,
  'total_edges' : bigint,
}
export interface Holder {
  'principal' : Principal,
  'balance' : bigint,
  'transactions' : bigint,
}
export interface Metadata {
  'decimals' : [] | [bigint],
  'logo' : [] | [string],
  'name' : [] | [string],
  'ledger' : Principal,
  'symbol' : [] | [string],
}
export type Mode = { 'native' : null } |
  { 'local_native' : null } |
  { 'local_mirror' : null };
export interface Page {
  'status' : { 'refreshing' : null } |
    { 'building' : null } |
    { 'error' : string } |
    { 'ready' : null },
  'snapshot' : [] | [Snapshot],
  'next_refresh_at' : bigint,
  'matching_count' : bigint,
  'mode' : Mode,
  'error' : [] | [string],
  'target' : bigint,
  'ledger' : [] | [Principal],
  'page_valid' : boolean,
  'market' : Principal,
  'items' : Array<Holder>,
  'next_offset' : [] | [bigint],
  'indexed' : bigint,
  'refresh_interval_seconds' : bigint,
}
export interface PageArgs {
  'principal' : [] | [Principal],
  'offset' : bigint,
  'limit' : bigint,
  'expected_version' : [] | [bigint],
}
export interface Pool {
  'fee' : bigint,
  'key' : string,
  'tickSpacing' : bigint,
  'token0' : Asset,
  'token1' : Asset,
  'canisterId' : Principal,
}
export interface PoolArgs {
  'offset' : bigint,
  'limit' : bigint,
  'ledger' : [] | [Principal],
  'expected_version' : [] | [bigint],
}
export interface PoolPage {
  'total' : bigint,
  'version' : bigint,
  'page_valid' : boolean,
  'items' : Array<Pool>,
  'next_offset' : [] | [bigint],
}
export interface QueueItem {
  'next_refresh_at' : bigint,
  'error' : [] | [string],
  'target' : bigint,
  'ledger' : [] | [Principal],
  'market' : Principal,
  'indexed' : bigint,
}
export interface Snapshot {
  'updated_at' : bigint,
  'holder_count' : bigint,
  'version' : bigint,
  'supply' : bigint,
  'indexed' : bigint,
}
export interface Status {
  'next_refresh_at' : bigint,
  'metadata_pending' : bigint,
  'pool_count' : bigint,
  'mode' : Mode,
  'truncated' : boolean,
  'last_success_at' : [] | [bigint],
  'error' : [] | [string],
  'version' : bigint,
  'complete' : boolean,
  'max_tokens' : bigint,
  'token_count' : bigint,
  'factory' : Principal,
  'last_attempt_at' : [] | [bigint],
  'max_pools' : bigint,
  'token_list' : Principal,
  'refresh_interval_seconds' : bigint,
}
export interface Token {
  'decimals' : [] | [bigint],
  'metadata_error' : [] | [string],
  'pool_count' : bigint,
  'logo' : [] | [string],
  'name' : [] | [string],
  'primary_pool' : Principal,
  'metadata_updated_at' : [] | [bigint],
  'ledger' : Principal,
  'standard' : string,
  'symbol' : [] | [string],
}
export interface TokenArgs {
  'offset' : bigint,
  'search' : string,
  'limit' : bigint,
  'expected_version' : [] | [bigint],
}
export interface TokenPage {
  'total' : bigint,
  'version' : bigint,
  'page_valid' : boolean,
  'items' : Array<Token>,
  'next_offset' : [] | [bigint],
}
export type Value = { 'Int' : bigint } |
  { 'Map' : Array<[string, Value]> } |
  { 'Nat' : bigint } |
  { 'Blob' : Uint8Array } |
  { 'Text' : string } |
  { 'Array' : Array<Value> };
export interface _SERVICE {
  'bubble_snapshot' : ActorMethod<[Principal, bigint], [] | [GraphPage]>,
  'configure_local' : ActorMethod<
    [
      {
        'mode' : { 'local_native' : null } |
          { 'local_mirror' : null },
        'factory' : [] | [Principal],
      },
    ],
    undefined
  >,
  'dex_configure_local' : ActorMethod<
    [
      {
        'mode' : { 'local_native' : null } |
          { 'local_mirror' : null },
        'factory' : [] | [Principal],
        'token_list' : [] | [Principal],
      },
    ],
    undefined
  >,
  'dex_mirror_snapshot' : ActorMethod<
    [Array<Pool>, Array<Metadata>, bigint],
    { 'ok' : bigint } |
      { 'err' : string }
  >,
  'dex_pools' : ActorMethod<[PoolArgs], PoolPage>,
  'dex_refresh_local' : ActorMethod<[], undefined>,
  'dex_status' : ActorMethod<[], Status>,
  'dex_tokens' : ActorMethod<[TokenArgs], TokenPage>,
  'holder_snapshot' : ActorMethod<[Principal, PageArgs], [] | [Page]>,
  'index_config' : ActorMethod<
    [],
    {
      'batch_size' : bigint,
      'mode' : Mode,
      'max_tokens' : bigint,
      'factory' : Principal,
      'refresh_interval_seconds' : bigint,
      'tracked_tokens' : bigint,
    }
  >,
  'maintenance_queue' : ActorMethod<
    [bigint, bigint],
    { 'total' : bigint, 'items' : Array<QueueItem> }
  >,
  'mirror_append' : ActorMethod<
    [Principal, Principal, bigint, Array<Block>],
    { 'ok' : bigint } |
      { 'err' : string }
  >,
  'mirror_error' : ActorMethod<[Principal, string], undefined>,
  'mirror_graph_append' : ActorMethod<
    [Principal, Principal, Array<Block>],
    { 'ok' : bigint } |
      { 'err' : string }
  >,
  'mirror_graph_error' : ActorMethod<[Principal, string], undefined>,
  'mirror_register' : ActorMethod<
    [Principal, Principal],
    { 'ok' : null } |
      { 'err' : string }
  >,
  'reject_local_market' : ActorMethod<[Principal], undefined>,
  'request_refresh' : ActorMethod<
    [Principal],
    { 'ok' : bigint } |
      { 'err' : string }
  >,
  'track' : ActorMethod<[Principal], { 'ok' : null } | { 'err' : string }>,
}
export const Value = IDL.Rec();
export const GraphEdge = IDL.Record({
  'to' : IDL.Principal,
  'from' : IDL.Principal,
  'transfers' : IDL.Nat,
  'last_block' : IDL.Nat,
  'first_block' : IDL.Nat,
  'amount' : IDL.Nat,
  'last_at' : IDL.Opt(IDL.Nat),
  'first_at' : IDL.Opt(IDL.Nat),
});
export const Holder = IDL.Record({
  'principal' : IDL.Principal,
  'balance' : IDL.Nat,
  'transactions' : IDL.Nat,
});
export const GraphSnapshot = IDL.Record({
  'omitted_edges' : IDL.Nat,
  'updated_at' : IDL.Nat64,
  'infrastructure_edges' : IDL.Nat,
  'transfers' : IDL.Nat,
  'edges' : IDL.Vec(GraphEdge),
  'omitted_infrastructure_transfers' : IDL.Nat,
  'omitted_transfers' : IDL.Nat,
  'holder_count' : IDL.Nat,
  'version' : IDL.Nat,
  'holder_edges' : IDL.Nat,
  'supply' : IDL.Nat,
  'holders' : IDL.Vec(Holder),
  'capped' : IDL.Bool,
  'omitted_peer_transfers' : IDL.Nat,
  'peer_edges' : IDL.Nat,
  'indexed' : IDL.Nat,
  'total_edges' : IDL.Nat,
});
export const Mode = IDL.Variant({
  'native' : IDL.Null,
  'local_native' : IDL.Null,
  'local_mirror' : IDL.Null,
});
export const GraphPage = IDL.Record({
  'status' : IDL.Variant({
    'refreshing' : IDL.Null,
    'building' : IDL.Null,
    'error' : IDL.Text,
    'ready' : IDL.Null,
  }),
  'snapshot' : IDL.Opt(GraphSnapshot),
  'next_refresh_at' : IDL.Nat64,
  'mode' : Mode,
  'max_edges' : IDL.Nat,
  'error' : IDL.Opt(IDL.Text),
  'target' : IDL.Nat,
  'max_infrastructure_edges' : IDL.Nat,
  'max_holders' : IDL.Nat,
  'ledger' : IDL.Opt(IDL.Principal),
  'market' : IDL.Principal,
  'max_tracked_edges' : IDL.Nat,
  'max_peer_edges' : IDL.Nat,
  'indexed' : IDL.Nat,
  'refresh_interval_seconds' : IDL.Nat,
});
export const Asset = IDL.Record({
  'address' : IDL.Text,
  'standard' : IDL.Text,
});
export const Pool = IDL.Record({
  'fee' : IDL.Nat,
  'key' : IDL.Text,
  'tickSpacing' : IDL.Int,
  'token0' : Asset,
  'token1' : Asset,
  'canisterId' : IDL.Principal,
});
export const Metadata = IDL.Record({
  'decimals' : IDL.Opt(IDL.Nat),
  'logo' : IDL.Opt(IDL.Text),
  'name' : IDL.Opt(IDL.Text),
  'ledger' : IDL.Principal,
  'symbol' : IDL.Opt(IDL.Text),
});
export const PoolArgs = IDL.Record({
  'offset' : IDL.Nat,
  'limit' : IDL.Nat,
  'ledger' : IDL.Opt(IDL.Principal),
  'expected_version' : IDL.Opt(IDL.Nat),
});
export const PoolPage = IDL.Record({
  'total' : IDL.Nat,
  'version' : IDL.Nat,
  'page_valid' : IDL.Bool,
  'items' : IDL.Vec(Pool),
  'next_offset' : IDL.Opt(IDL.Nat),
});
export const Status = IDL.Record({
  'next_refresh_at' : IDL.Nat64,
  'metadata_pending' : IDL.Nat,
  'pool_count' : IDL.Nat,
  'mode' : Mode,
  'truncated' : IDL.Bool,
  'last_success_at' : IDL.Opt(IDL.Nat64),
  'error' : IDL.Opt(IDL.Text),
  'version' : IDL.Nat,
  'complete' : IDL.Bool,
  'max_tokens' : IDL.Nat,
  'token_count' : IDL.Nat,
  'factory' : IDL.Principal,
  'last_attempt_at' : IDL.Opt(IDL.Nat64),
  'max_pools' : IDL.Nat,
  'token_list' : IDL.Principal,
  'refresh_interval_seconds' : IDL.Nat,
});
export const TokenArgs = IDL.Record({
  'offset' : IDL.Nat,
  'search' : IDL.Text,
  'limit' : IDL.Nat,
  'expected_version' : IDL.Opt(IDL.Nat),
});
export const Token = IDL.Record({
  'decimals' : IDL.Opt(IDL.Nat),
  'metadata_error' : IDL.Opt(IDL.Text),
  'pool_count' : IDL.Nat,
  'logo' : IDL.Opt(IDL.Text),
  'name' : IDL.Opt(IDL.Text),
  'primary_pool' : IDL.Principal,
  'metadata_updated_at' : IDL.Opt(IDL.Nat64),
  'ledger' : IDL.Principal,
  'standard' : IDL.Text,
  'symbol' : IDL.Opt(IDL.Text),
});
export const TokenPage = IDL.Record({
  'total' : IDL.Nat,
  'version' : IDL.Nat,
  'page_valid' : IDL.Bool,
  'items' : IDL.Vec(Token),
  'next_offset' : IDL.Opt(IDL.Nat),
});
export const PageArgs = IDL.Record({
  'principal' : IDL.Opt(IDL.Principal),
  'offset' : IDL.Nat,
  'limit' : IDL.Nat,
  'expected_version' : IDL.Opt(IDL.Nat),
});
export const Snapshot = IDL.Record({
  'updated_at' : IDL.Nat64,
  'holder_count' : IDL.Nat,
  'version' : IDL.Nat,
  'supply' : IDL.Nat,
  'indexed' : IDL.Nat,
});
export const Page = IDL.Record({
  'status' : IDL.Variant({
    'refreshing' : IDL.Null,
    'building' : IDL.Null,
    'error' : IDL.Text,
    'ready' : IDL.Null,
  }),
  'snapshot' : IDL.Opt(Snapshot),
  'next_refresh_at' : IDL.Nat64,
  'matching_count' : IDL.Nat,
  'mode' : Mode,
  'error' : IDL.Opt(IDL.Text),
  'target' : IDL.Nat,
  'ledger' : IDL.Opt(IDL.Principal),
  'page_valid' : IDL.Bool,
  'market' : IDL.Principal,
  'items' : IDL.Vec(Holder),
  'next_offset' : IDL.Opt(IDL.Nat),
  'indexed' : IDL.Nat,
  'refresh_interval_seconds' : IDL.Nat,
});
export const QueueItem = IDL.Record({
  'next_refresh_at' : IDL.Nat64,
  'error' : IDL.Opt(IDL.Text),
  'target' : IDL.Nat,
  'ledger' : IDL.Opt(IDL.Principal),
  'market' : IDL.Principal,
  'indexed' : IDL.Nat,
});
Value.fill(
  IDL.Variant({
    'Int' : IDL.Int,
    'Map' : IDL.Vec(IDL.Tuple(IDL.Text, Value)),
    'Nat' : IDL.Nat,
    'Blob' : IDL.Vec(IDL.Nat8),
    'Text' : IDL.Text,
    'Array' : IDL.Vec(Value),
  })
);
export const Block = IDL.Record({ 'id' : IDL.Nat, 'block' : Value });

export const idlService: IDL.ServiceClass = IDL.Service({
  'bubble_snapshot' : IDL.Func(
      [IDL.Principal, IDL.Nat],
      [IDL.Opt(GraphPage)],
      ['query'],
    ),
  'configure_local' : IDL.Func(
      [
        IDL.Record({
          'mode' : IDL.Variant({
            'local_native' : IDL.Null,
            'local_mirror' : IDL.Null,
          }),
          'factory' : IDL.Opt(IDL.Principal),
        }),
      ],
      [],
      [],
    ),
  'dex_configure_local' : IDL.Func(
      [
        IDL.Record({
          'mode' : IDL.Variant({
            'local_native' : IDL.Null,
            'local_mirror' : IDL.Null,
          }),
          'factory' : IDL.Opt(IDL.Principal),
          'token_list' : IDL.Opt(IDL.Principal),
        }),
      ],
      [],
      [],
    ),
  'dex_mirror_snapshot' : IDL.Func(
      [IDL.Vec(Pool), IDL.Vec(Metadata), IDL.Nat64],
      [IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text })],
      [],
    ),
  'dex_pools' : IDL.Func([PoolArgs], [PoolPage], ['query']),
  'dex_refresh_local' : IDL.Func([], [], []),
  'dex_status' : IDL.Func([], [Status], ['query']),
  'dex_tokens' : IDL.Func([TokenArgs], [TokenPage], ['query']),
  'holder_snapshot' : IDL.Func(
      [IDL.Principal, PageArgs],
      [IDL.Opt(Page)],
      ['query'],
    ),
  'index_config' : IDL.Func(
      [],
      [
        IDL.Record({
          'batch_size' : IDL.Nat,
          'mode' : Mode,
          'max_tokens' : IDL.Nat,
          'factory' : IDL.Principal,
          'refresh_interval_seconds' : IDL.Nat,
          'tracked_tokens' : IDL.Nat,
        }),
      ],
      ['query'],
    ),
  'maintenance_queue' : IDL.Func(
      [IDL.Nat, IDL.Nat],
      [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(QueueItem) })],
      ['query'],
    ),
  'mirror_append' : IDL.Func(
      [IDL.Principal, IDL.Principal, IDL.Nat, IDL.Vec(Block)],
      [IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text })],
      [],
    ),
  'mirror_error' : IDL.Func([IDL.Principal, IDL.Text], [], []),
  'mirror_graph_append' : IDL.Func(
      [IDL.Principal, IDL.Principal, IDL.Vec(Block)],
      [IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text })],
      [],
    ),
  'mirror_graph_error' : IDL.Func([IDL.Principal, IDL.Text], [], []),
  'mirror_register' : IDL.Func(
      [IDL.Principal, IDL.Principal],
      [IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text })],
      [],
    ),
  'reject_local_market' : IDL.Func([IDL.Principal], [], []),
  'request_refresh' : IDL.Func(
      [IDL.Principal],
      [IDL.Variant({ 'ok' : IDL.Nat64, 'err' : IDL.Text })],
      [],
    ),
  'track' : IDL.Func(
      [IDL.Principal],
      [IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text })],
      [],
    ),
});

export const idlInitArgs: IDL.Type[] = [];

export const idlFactory: IDL.InterfaceFactory = ({ IDL }) => {
  const Value = IDL.Rec();
  const GraphEdge = IDL.Record({
    'to' : IDL.Principal,
    'from' : IDL.Principal,
    'transfers' : IDL.Nat,
    'last_block' : IDL.Nat,
    'first_block' : IDL.Nat,
    'amount' : IDL.Nat,
    'last_at' : IDL.Opt(IDL.Nat),
    'first_at' : IDL.Opt(IDL.Nat),
  });
  const Holder = IDL.Record({
    'principal' : IDL.Principal,
    'balance' : IDL.Nat,
    'transactions' : IDL.Nat,
  });
  const GraphSnapshot = IDL.Record({
    'omitted_edges' : IDL.Nat,
    'updated_at' : IDL.Nat64,
    'infrastructure_edges' : IDL.Nat,
    'transfers' : IDL.Nat,
    'edges' : IDL.Vec(GraphEdge),
    'omitted_infrastructure_transfers' : IDL.Nat,
    'omitted_transfers' : IDL.Nat,
    'holder_count' : IDL.Nat,
    'version' : IDL.Nat,
    'holder_edges' : IDL.Nat,
    'supply' : IDL.Nat,
    'holders' : IDL.Vec(Holder),
    'capped' : IDL.Bool,
    'omitted_peer_transfers' : IDL.Nat,
    'peer_edges' : IDL.Nat,
    'indexed' : IDL.Nat,
    'total_edges' : IDL.Nat,
  });
  const Mode = IDL.Variant({
    'native' : IDL.Null,
    'local_native' : IDL.Null,
    'local_mirror' : IDL.Null,
  });
  const GraphPage = IDL.Record({
    'status' : IDL.Variant({
      'refreshing' : IDL.Null,
      'building' : IDL.Null,
      'error' : IDL.Text,
      'ready' : IDL.Null,
    }),
    'snapshot' : IDL.Opt(GraphSnapshot),
    'next_refresh_at' : IDL.Nat64,
    'mode' : Mode,
    'max_edges' : IDL.Nat,
    'error' : IDL.Opt(IDL.Text),
    'target' : IDL.Nat,
    'max_infrastructure_edges' : IDL.Nat,
    'max_holders' : IDL.Nat,
    'ledger' : IDL.Opt(IDL.Principal),
    'market' : IDL.Principal,
    'max_tracked_edges' : IDL.Nat,
    'max_peer_edges' : IDL.Nat,
    'indexed' : IDL.Nat,
    'refresh_interval_seconds' : IDL.Nat,
  });
  const Asset = IDL.Record({ 'address' : IDL.Text, 'standard' : IDL.Text });
  const Pool = IDL.Record({
    'fee' : IDL.Nat,
    'key' : IDL.Text,
    'tickSpacing' : IDL.Int,
    'token0' : Asset,
    'token1' : Asset,
    'canisterId' : IDL.Principal,
  });
  const Metadata = IDL.Record({
    'decimals' : IDL.Opt(IDL.Nat),
    'logo' : IDL.Opt(IDL.Text),
    'name' : IDL.Opt(IDL.Text),
    'ledger' : IDL.Principal,
    'symbol' : IDL.Opt(IDL.Text),
  });
  const PoolArgs = IDL.Record({
    'offset' : IDL.Nat,
    'limit' : IDL.Nat,
    'ledger' : IDL.Opt(IDL.Principal),
    'expected_version' : IDL.Opt(IDL.Nat),
  });
  const PoolPage = IDL.Record({
    'total' : IDL.Nat,
    'version' : IDL.Nat,
    'page_valid' : IDL.Bool,
    'items' : IDL.Vec(Pool),
    'next_offset' : IDL.Opt(IDL.Nat),
  });
  const Status = IDL.Record({
    'next_refresh_at' : IDL.Nat64,
    'metadata_pending' : IDL.Nat,
    'pool_count' : IDL.Nat,
    'mode' : Mode,
    'truncated' : IDL.Bool,
    'last_success_at' : IDL.Opt(IDL.Nat64),
    'error' : IDL.Opt(IDL.Text),
    'version' : IDL.Nat,
    'complete' : IDL.Bool,
    'max_tokens' : IDL.Nat,
    'token_count' : IDL.Nat,
    'factory' : IDL.Principal,
    'last_attempt_at' : IDL.Opt(IDL.Nat64),
    'max_pools' : IDL.Nat,
    'token_list' : IDL.Principal,
    'refresh_interval_seconds' : IDL.Nat,
  });
  const TokenArgs = IDL.Record({
    'offset' : IDL.Nat,
    'search' : IDL.Text,
    'limit' : IDL.Nat,
    'expected_version' : IDL.Opt(IDL.Nat),
  });
  const Token = IDL.Record({
    'decimals' : IDL.Opt(IDL.Nat),
    'metadata_error' : IDL.Opt(IDL.Text),
    'pool_count' : IDL.Nat,
    'logo' : IDL.Opt(IDL.Text),
    'name' : IDL.Opt(IDL.Text),
    'primary_pool' : IDL.Principal,
    'metadata_updated_at' : IDL.Opt(IDL.Nat64),
    'ledger' : IDL.Principal,
    'standard' : IDL.Text,
    'symbol' : IDL.Opt(IDL.Text),
  });
  const TokenPage = IDL.Record({
    'total' : IDL.Nat,
    'version' : IDL.Nat,
    'page_valid' : IDL.Bool,
    'items' : IDL.Vec(Token),
    'next_offset' : IDL.Opt(IDL.Nat),
  });
  const PageArgs = IDL.Record({
    'principal' : IDL.Opt(IDL.Principal),
    'offset' : IDL.Nat,
    'limit' : IDL.Nat,
    'expected_version' : IDL.Opt(IDL.Nat),
  });
  const Snapshot = IDL.Record({
    'updated_at' : IDL.Nat64,
    'holder_count' : IDL.Nat,
    'version' : IDL.Nat,
    'supply' : IDL.Nat,
    'indexed' : IDL.Nat,
  });
  const Page = IDL.Record({
    'status' : IDL.Variant({
      'refreshing' : IDL.Null,
      'building' : IDL.Null,
      'error' : IDL.Text,
      'ready' : IDL.Null,
    }),
    'snapshot' : IDL.Opt(Snapshot),
    'next_refresh_at' : IDL.Nat64,
    'matching_count' : IDL.Nat,
    'mode' : Mode,
    'error' : IDL.Opt(IDL.Text),
    'target' : IDL.Nat,
    'ledger' : IDL.Opt(IDL.Principal),
    'page_valid' : IDL.Bool,
    'market' : IDL.Principal,
    'items' : IDL.Vec(Holder),
    'next_offset' : IDL.Opt(IDL.Nat),
    'indexed' : IDL.Nat,
    'refresh_interval_seconds' : IDL.Nat,
  });
  const QueueItem = IDL.Record({
    'next_refresh_at' : IDL.Nat64,
    'error' : IDL.Opt(IDL.Text),
    'target' : IDL.Nat,
    'ledger' : IDL.Opt(IDL.Principal),
    'market' : IDL.Principal,
    'indexed' : IDL.Nat,
  });
  Value.fill(
    IDL.Variant({
      'Int' : IDL.Int,
      'Map' : IDL.Vec(IDL.Tuple(IDL.Text, Value)),
      'Nat' : IDL.Nat,
      'Blob' : IDL.Vec(IDL.Nat8),
      'Text' : IDL.Text,
      'Array' : IDL.Vec(Value),
    })
  );
  const Block = IDL.Record({ 'id' : IDL.Nat, 'block' : Value });

  return IDL.Service({
    'bubble_snapshot' : IDL.Func(
        [IDL.Principal, IDL.Nat],
        [IDL.Opt(GraphPage)],
        ['query'],
      ),
    'configure_local' : IDL.Func(
        [
          IDL.Record({
            'mode' : IDL.Variant({
              'local_native' : IDL.Null,
              'local_mirror' : IDL.Null,
            }),
            'factory' : IDL.Opt(IDL.Principal),
          }),
        ],
        [],
        [],
      ),
    'dex_configure_local' : IDL.Func(
        [
          IDL.Record({
            'mode' : IDL.Variant({
              'local_native' : IDL.Null,
              'local_mirror' : IDL.Null,
            }),
            'factory' : IDL.Opt(IDL.Principal),
            'token_list' : IDL.Opt(IDL.Principal),
          }),
        ],
        [],
        [],
      ),
    'dex_mirror_snapshot' : IDL.Func(
        [IDL.Vec(Pool), IDL.Vec(Metadata), IDL.Nat64],
        [IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text })],
        [],
      ),
    'dex_pools' : IDL.Func([PoolArgs], [PoolPage], ['query']),
    'dex_refresh_local' : IDL.Func([], [], []),
    'dex_status' : IDL.Func([], [Status], ['query']),
    'dex_tokens' : IDL.Func([TokenArgs], [TokenPage], ['query']),
    'holder_snapshot' : IDL.Func(
        [IDL.Principal, PageArgs],
        [IDL.Opt(Page)],
        ['query'],
      ),
    'index_config' : IDL.Func(
        [],
        [
          IDL.Record({
            'batch_size' : IDL.Nat,
            'mode' : Mode,
            'max_tokens' : IDL.Nat,
            'factory' : IDL.Principal,
            'refresh_interval_seconds' : IDL.Nat,
            'tracked_tokens' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'maintenance_queue' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(QueueItem) })],
        ['query'],
      ),
    'mirror_append' : IDL.Func(
        [IDL.Principal, IDL.Principal, IDL.Nat, IDL.Vec(Block)],
        [IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text })],
        [],
      ),
    'mirror_error' : IDL.Func([IDL.Principal, IDL.Text], [], []),
    'mirror_graph_append' : IDL.Func(
        [IDL.Principal, IDL.Principal, IDL.Vec(Block)],
        [IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text })],
        [],
      ),
    'mirror_graph_error' : IDL.Func([IDL.Principal, IDL.Text], [], []),
    'mirror_register' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text })],
        [],
      ),
    'reject_local_market' : IDL.Func([IDL.Principal], [], []),
    'request_refresh' : IDL.Func(
        [IDL.Principal],
        [IDL.Variant({ 'ok' : IDL.Nat64, 'err' : IDL.Text })],
        [],
      ),
    'track' : IDL.Func(
        [IDL.Principal],
        [IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text })],
        [],
      ),
  });
};

export const init: (args: { IDL: typeof IDL }) => IDL.Type[] = ({ IDL }) => {
  return [];
};
